import { useRouteError, isRouteErrorResponse, Link } from "react-router";
import { AlertTriangle, Home, RefreshCw } from "lucide-react";
import classNames from "classnames";

const ErrorPage = () => {
  const error = useRouteError();

  let errorMessage = "An unexpected error occurred.";
  let errorTitle = "Something went wrong";

  if (isRouteErrorResponse(error)) {
    errorMessage = error.statusText || error.data?.message || "Page not found";
    errorTitle = `${error.status} ${error.statusText}`;
    if (error.status === 404) {
      errorTitle = "Page Not Found";
      errorMessage = "Sorry, we couldn't find the page you're looking for.";
    }
  } else if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === "string") {
    errorMessage = error;
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-black text-white p-4">
      <div className="bg-dark-2 border border-dark-1 rounded-2xl p-8 max-w-md w-full text-center shadow-2xl">
        <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <AlertTriangle size={32} className="text-red-500" />
        </div>

        <h1 className="text-2xl font-bold font-redhat-display mb-2 text-white">
          {errorTitle}
        </h1>

        <p className="text-white/60 mb-8 font-inter text-sm leading-relaxed break-words">
          {errorMessage}
        </p>

        <div className="flex gap-3 justify-center">
          <button
            onClick={() => window.location.reload()}
            className="flex items-center gap-2 px-4 py-2 bg-dark-1 hover:bg-dark-3 rounded-xl transition-colors text-sm font-bold"
          >
            <RefreshCw size={16} />
            Refresh
          </button>

          <Link
            to="/"
            className="flex items-center gap-2 px-4 py-2 bg-primary-1 hover:bg-blue-600 rounded-xl transition-colors text-sm font-bold"
          >
            <Home size={16} />
            Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
